export default __webpack_public_path__ + "static/media/8.048a6543.jpeg";